import React from 'react';
import Skeleton from '../../common/skeleton';

const ReportsDynamicFormSkeleton = () => {
  return (
    <div>
      <div className="mt-3 mb-5">
        <Skeleton height={40} width={200} count={1} />
      </div>
      <div>
        <Skeleton height={45} width={'100%'} className={'mb-4'} />
      </div>
      <div>
        <Skeleton height={45} width={'100%'} className={'mb-4'} />
      </div>
      <div>
        <Skeleton height={45} width={'100%'} className={'mb-3'} />
      </div>
      <div className="my-3 text-right">
        <Skeleton height={40} width={180} />
      </div>
    </div>
  );
};

export default ReportsDynamicFormSkeleton;
